import React, { useContext } from 'react';
import { Row, Col } from '@thd-olt-component-react/core-ui';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import Responsive from 'react-responsive';
import { UserInfoModel } from '../common/models/UserInfoModel';
import { DataContext, DataProvider } from '../contexts/DataContext';
import { WelcomeCardHeader } from './WelcomeCardHeader/WelcomeCardHeader';
import { SpendSummary } from './SpendSummary/SpendSummary';
import { WelcomeCardFooter, ProXtraLinks } from './WelcomeCardFooter';
import { PromotionSection } from './PromotionSection';
import { NotificationSection } from './NotificationSection';
import { WelcomeCardErrorPage } from './WelcomeCardErrorPage/WelcomeCardErrorPage';
import { TabletWelcomeCard } from './TabletWelcomeCard/TabletWelcomeCard';
import './LoyaltyBenefits.scss';

const exportsForTesting = {};

const App = () => {
  const { channel } = useContext(ExperienceContext);
  const {
    isLoading, refreshData, tiles, isAdmin, userDataError
  } = useContext(DataContext);
  const isMobile = channel === 'mobile';

  const handleOnClick = () => {
    refreshData();
  };

  const WelcomeCard = () => {
    return (
      <Col className="loyalty_benefits__welcomeCard">
        <section>
          <div className="wrapper">
            <header className="page-header">
              <WelcomeCardHeader />
            </header>
            <main>
              {!isMobile && isAdmin && <SpendSummary />}
              <NotificationSection tiles={tiles.NOTIFICATION} />
            </main>
            <footer className="page-footer loyalty_benefits__footerSection">
              {!isMobile && <PromotionSection tiles={tiles.PROMOTION} />}
              {!isMobile && isAdmin && <ProXtraLinks />}
              <WelcomeCardFooter />
            </footer>
          </div>
        </section>
      </Col>
    );
  };

  const RenderWelcomeCard = () => {
    return (
      <Row xs="12" sm="12" md="12" lg="12">
        {(!isLoading && !userDataError) ? <WelcomeCard /> : (
          <WelcomeCardErrorPage
            handleOnClick={handleOnClick}
            cardLoaded={!isLoading}
          />
        )}
      </Row>
    );
  };

  const RenderLoyaltyBenefits = () => {
    // eslint-disable-next-line react/destructuring-assignment
    const DesktopView = (props) => <Responsive minWidth={1025}>{props.children}</Responsive>;
    // eslint-disable-next-line react/destructuring-assignment
    const TabletView = (props) => <Responsive minWidth={768} maxWidth={1024}>{props.children}</Responsive>;
    // eslint-disable-next-line react/destructuring-assignment
    const MobileView = (props) => <Responsive maxWidth={767}>{props.children}</Responsive>;

    return (
      <>
        <MobileView>
          <RenderWelcomeCard />
        </MobileView>
        <TabletView>
          <TabletWelcomeCard
            handleOnClick={handleOnClick}
          />
        </TabletView>
        <DesktopView>
          <RenderWelcomeCard />
        </DesktopView>
      </>
    );
  };

  exportsForTesting.handleOnClick = handleOnClick;
  exportsForTesting.WelcomeCard = WelcomeCard;
  exportsForTesting.RenderWelcomeCard = RenderWelcomeCard;
  exportsForTesting.RenderLoyaltyBenefits = RenderLoyaltyBenefits;

  return <RenderLoyaltyBenefits />;
};

const LoyaltyBenefits = () => (
  <DataProvider>
    <App />
  </DataProvider>
);

LoyaltyBenefits.displayName = 'Loyalty Benefits';

LoyaltyBenefits.dataModel = UserInfoModel;

export { LoyaltyBenefits, exportsForTesting };
